import { render, staticRenderFns } from "./_HlaAntibodies.vue?vue&type=template&id=8fb586b0"
import script from "./_HlaAntibodies.vue?vue&type=script&lang=ts"
export * from "./_HlaAntibodies.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports